import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

// A picture placed inside the form (programme banners, sponsor marks) — not an applicant upload.
// Applicant file upload is explicitly out of v1 (docs/00-DELIVERY-PACK-README.md scope boundaries).
const configSchema = z.object({
  assetId: z.string().optional(),
  altText: z.string().max(300).default(""),
  width: z.enum(["full", "half", "third"]).default("full"),
  align: z.enum(["left", "center", "right"]).default("center"),
});

export const imageField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "image",
  label: "Image",
  category: "layout",
  icon: "Image",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { altText: "", width: "full", align: "center" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
